module.exports = __webpack_public_path__ + "c081a5b04623e642f5f3ffcdd29a0775.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/festival05.jpg
// module id = 655
// module chunks = 0